import axios from "axios";

// Many pages call the API with plain axios instead of service/api.js. Give those requests the
// login token too, since the backend now requires it on every /api route. Requests that already
// set an Authorization header, or that go to other sites, are left alone.
axios.interceptors.request.use((config) => {
  const url = config.url || "";
  const ownApi = url.startsWith("/api/") || url.startsWith(`${window.location.origin}/api/`);
  const headers = config.headers || {};
  if (ownApi && !headers.Authorization && !headers.authorization) {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      if (user && user.token) {
        config.headers = { ...headers, Authorization: `Bearer ${user.token}` };
      }
    } catch (e) {
      // no usable login in storage; send the request as it is
    }
  }
  return config;
});
